































import ListItem from '@/components/list/ListItem.vue'
import {ErrorAction} from '@/store/modules/layout/types'
import {Component, Prop, Vue} from 'vue-property-decorator'

@Component({
  components: {
    ListItem,
  },
})
export default class ErrorItem extends Vue {
  @Prop() message: string
  @Prop() id: string
  @Prop() autoClose: boolean
  @Prop() action: ErrorAction

  get rightIconName() {
    const {action: {kind} = {} as any} = this
    switch(kind) {
      case 'redirect':
        return 'arrow-right-sm'
      case 'refresh':
        return 'refresh-sm'
      case 'close':
        return 'cancel-sm'
      default:
        return 'cancel-sm'
    }
  }

  onAction() {
    const {action} = this
    this.$emit('act', action)
  }
}
